module.exports = __webpack_public_path__ + "static/media/spreadsheet.e0131e5b.svg";